import './index.less';
import React, { PropsWithChildren, ReactElement, ReactNode, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { ChevronDownIcon } from '@/componentsUI/Icon';
import { CollapseItemPlusType, CollapseItemPlusUIProps } from './CollapseItemPlusUI/CollapseItemPlusUI';
import { CSSTransition } from 'react-transition-group';
export interface CollapsePlusUIProps {
  /**
   * 折叠左侧
   */
  collapsedLeft?: boolean;
  /**
   * 折叠到顶部
   */
  defaultCollapsedTop?: boolean;

  /**
   * icon
   */
  icon?: ReactNode;
  /**
   * title
   */
  title?: string;
  /**
   * 样式名字
   */
  className?: string;
  /**
   * 重置状态
   */
  value?: number | 'self';

  /**
   * 点击事件
   */
  onClick?: () => void;

  /**
   * 点击后是否自动合上
   */
  isAutoCollapsedTop?: boolean;

  scrollRef?: any;
}

const getCollapseItemPlusChildren = (props: any) => {
  const { children } = props;
  const collapseItemPlusChildren = [];
  React.Children.forEach(children, (child: ReactElement) => {
    if (child && child.type && (child as ReactElement<CollapseItemPlusUIProps, CollapseItemPlusType>).type.isCollapseItemPlus) {
      collapseItemPlusChildren.push(child);
    }
  });
  return collapseItemPlusChildren as ReactElement<CollapseItemPlusUIProps, CollapseItemPlusType>[];
};

export interface IFCollapsePlusContext {
  index?: any;
  onSelect?: (index: number, success?: boolean) => void;
}

export const CollapsePlusContext = React.createContext<IFCollapsePlusContext>({
  index: -1,
});

const CollapsePlusUI = (props: PropsWithChildren<CollapsePlusUIProps>) => {
  const { collapsedLeft, defaultCollapsedTop, icon, title, className, value, onClick, isAutoCollapsedTop, scrollRef } = props;

  const [collapsedTop, setCollapsedTop] = useState(defaultCollapsedTop);
  const collapseItemPlusChildren = getCollapseItemPlusChildren(props);
  const isAlone = collapseItemPlusChildren.length === 0;
  const prefixCls = 'collapse-plus-ui';
  const ref = useRef(null);
  const childRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState<number>(-1);
  const [visible, setVisible] = useState<boolean>(false);
  const handleClick = (index, success) => {
    if (success) {
      setCurrentIndex(index);
    }
    if (isAutoCollapsedTop) {
      setCollapsedTop(false);
    }
  };

  const handleClickHead = () => {
    onClick && onClick();
    !isAlone && setCollapsedTop(!collapsedTop);
  };

  useEffect(() => {
    if (value !== 'self') {
      setCurrentIndex(value);
    }
  }, [value]);

  const childContext: IFCollapsePlusContext = {
    index: currentIndex,
    onSelect: handleClick,
  };
  const handleMouseEnter = () => {
    setVisible(true);
  };

  const handleMouseLeave = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (!scrollRef || !scrollRef.current) {
      return;
    }
    let top = ref.current.offsetTop;
    let current = ref.current.offsetParent;
    while (current !== null) {
      top += current.offsetTop;
      current = current.offsetParent;
    }
    top -= scrollRef.current.scrollTop;
    if (childRef.current) {
      childRef.current.style.top = top + 'px';
      childRef.current.style.paddingLeft = '68px';
    }
  }, [visible]);

  return (
    <div
      className={classNames([prefixCls, className])}
      onMouseEnter={() => {
        !isAlone && collapsedLeft && handleMouseEnter();
      }}
    >
      <div
        className={classNames([
          `${prefixCls}-head`,
          collapsedTop && !collapsedLeft ? `${prefixCls}-collapsed-top-head` : '',
          value === 'self' && isAlone ? `${prefixCls}-checked-head` : '',
        ])}
        onClick={handleClickHead}
        ref={ref}
      >
        <div className="l">{icon}</div>
        <span className={classNames(['m', collapsedLeft ? 'collapsed-left-hidden-other' : ''])}>{title}</span>
        {!isAlone && (
          <div className={classNames(['r', collapsedLeft ? 'collapsed-left-hidden-other' : ''])}>
            <ChevronDownIcon />
          </div>
        )}
      </div>
      <CollapsePlusContext.Provider value={{ ...childContext }}>
        {!collapsedLeft && !isAlone && (
          <div
            style={{
              height: collapsedTop ? collapseItemPlusChildren.length * 44 + 'px' : '0px',
            }}
            className={classNames([`${prefixCls}-children`])}
          >
            {collapseItemPlusChildren}
          </div>
        )}

        {collapsedLeft && (
          <CSSTransition
            nodeRef={childRef}
            in={visible}
            timeout={0}
            unmountOnExit={true}
            classNames="my-node"
            appear
          >
            <div
              ref={childRef}
              onMouseEnter={handleMouseEnter}
              className={`${prefixCls}-children-float`}
              onMouseLeave={handleMouseLeave}
              onClick={() => {
                handleMouseLeave();
              }}
            >
              {collapseItemPlusChildren}
            </div>
          </CSSTransition>
        )}
      </CollapsePlusContext.Provider>
    </div>
  );
};

export default CollapsePlusUI;
